import { find, isNumber } from 'underscore';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';

export const dropdownValue = {
  Increase: 'Increase by',
  Decrease: 'Decrease by',
};

export const modelToViewModelForBidAdjustment = (data, disableDecrease) => ({
  bidAdjustmentDropdown: disableDecrease || data >= 0 ? dropdownValue.Increase : dropdownValue.Decrease,
  bidAdjustmentInput: disableDecrease ? data : Math.abs(data),
});

const parseBidAdjustmentValue = (data, i18n) => (isNumber(data) ? data : i18n.parseDecimal(data));

export const viewModelToModelForBidAdjustment = (data, i18n) => (data.bidAdjustmentDropdown === dropdownValue.Increase ? parseBidAdjustmentValue(data.bidAdjustmentInput, i18n) : -parseBidAdjustmentValue(data.bidAdjustmentInput, i18n));

export const modelToViewModelForMultiMediaBidAdjustment = (level, campaignLevelValue, adgroupLevelData) => ({
  multimediaAds: {
    currentLevelData: level === ScopeLevel.AdGroup ? modelToViewModelForBidAdjustment(adgroupLevelData, true) : modelToViewModelForBidAdjustment(campaignLevelValue, true),
    parentLevelData: level === ScopeLevel.AdGroup ? modelToViewModelForBidAdjustment(campaignLevelValue, true) : undefined,
    useParentLevel: level === ScopeLevel.AdGroup && !adgroupLevelData,
  },
});

export const modelToViewModelForAutomatedCallToActionOptOut = (data) => {
  const campaignSettings = data.CampaignSettings;
  const callToActionSetting = campaignSettings && find(campaignSettings, setting => setting['@odata.type'] === '#Model.CallToActionSetting');
  return {
    AutomatedCallToActionOptOut: callToActionSetting && callToActionSetting.AutomatedCallToActionOptOut,
  };
};

export const viewModelToModelForMultiMediaAdBidAdjustment = (level, viewmodel, i18n) => {
  if (!viewmodel.multimediaAds) {
    return {};
  }

  const { currentLevelData, useParentLevel } = viewmodel.multimediaAds;
  return { MultimediaAdBidAdjustment: level === ScopeLevel.AdGroup && useParentLevel ? null : viewModelToModelForBidAdjustment(currentLevelData, i18n) };
};
